"use client";

import { FreeDigitalReportHeroButton } from "@/components/shared/DigitalReportLeadProvider";

/**
 * Same headline stack as `DigitalReportLeadForm` (caption + title). Title uses article body color for the
 * light sidebar surface.
 */
export function ArticleDigitalReportSidebarPrompt() {
  return (
    <div className="font-sans">
      <header>
        <div className="flex flex-col gap-2 text-[#627d92]">
          <p className="text-sm font-medium tracking-tight uppercase">
            Just how visible is your digital presence
          </p>
        </div>
        <h2 className="mt-4 text-3xl leading-[0.9em] tracking-tighter text-[#231f20] sm:text-4xl lg:text-5xl xl:text-6xl">
          Get your free <span className="text-[#ff5c00]">digital report</span>
        </h2>
        <div className="mt-8">
          <FreeDigitalReportHeroButton className="inline-flex cursor-pointer items-center justify-center rounded-md bg-[#f16e33] px-8 py-3.5 text-sm font-bold uppercase tracking-wide text-white transition-opacity hover:opacity-90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white disabled:cursor-not-allowed disabled:opacity-60">
            Free Digital Report
          </FreeDigitalReportHeroButton>
        </div>
      </header>
    </div>
  );
}
